var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.9h-7.3V17c0-.1 0-.1-.1-.2s-.1-.1-.2-.1h-1.6c-.1 0-.1 0-.2.1s-.1.1-.1.2v1.9h-1.9c-.1 0-.1 0-.2.1s-.1.1-.1.2v1.6c0 .1 0 .1.1.2s.1.1.2.1h1.9v7.4c0 .1 0 .1.1.2s.1.1.2.1h7.4v1.9c0 .1 0 .1.1.2s.1.1.2.1h1.6c.1 0 .1 0 .2-.1s.1-.1.1-.2v-1.9h1.9c.1 0 .1 0 .2-.1s.1-.1.1-.2v-1.6c0-.1 0-.1-.1-.2s-.1-.1-.2-.1h-1.9V19m-2.2 7.5h-5.6V21h5.6v5.5z"
  })));
};
export default SvgCrop;